import Image from '@ui/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf'
import { Container, Row, Col } from '@ui/wrapper'
import {
  BoxImgWrapper,
  BoxImgInner,
  BoxImgMedia,
  BoxImgContent,
  HeadingWrap,
  HeadingWrap2,
  TextWrap
} from './style'

const BoxImage = ({
  designation,
  image,
  title,
  desc,
  path = '/',
  icon = faFilePdf,
  className,
  showTitle = true,
  leftCol = 3,
  rightCol = 9,
  ...restProps
}) => {
  return (
    <BoxImgWrapper className={className} {...restProps}>
      <BoxImgInner>
        <Container>
          <Row alignItems="center">
            {image?.src && (
              <Col lg={leftCol}>
                <BoxImgMedia>
                  <Image
                    src={image.src.localFile?.publicURL || image.src}
                    alt={title}
                  />
                </BoxImgMedia>
              </Col>
            )}
            <Col lg={rightCol}>
              <BoxImgContent>
                {title && showTitle && <HeadingWrap>{title}</HeadingWrap>}
                {desc && (
                  <TextWrap
                    dangerouslySetInnerHTML={{
                      __html: desc
                    }}
                  />
                )}
                {icon && (
                  <HeadingWrap2>
                    <a href={path} target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon
                        icon={icon}
                        style={{ marginRight: '0.5em' }}
                      />
                      {designation || title}
                    </a>
                  </HeadingWrap2>
                )}
              </BoxImgContent>
            </Col>
          </Row>
        </Container>
      </BoxImgInner>
    </BoxImgWrapper>
  )
}

export default BoxImage
